import { render } from "./DeleteFilesDevices.vue?vue&type=template&id=6bd406b5"
import script from "./DeleteFilesDevices.vue?vue&type=script&lang=js"
export * from "./DeleteFilesDevices.vue?vue&type=script&lang=js"

import "./DeleteFilesDevices.vue?vue&type=style&index=0&id=6bd406b5&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__